/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Back_HomeInputs */

const en_tools_back_home = /** @type {(inputs: Tools_Back_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to home`)
};

const id_tools_back_home = /** @type {(inputs: Tools_Back_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kembali ke beranda`)
};

/**
* | output |
* | --- |
* | "Back to home" |
*
* @param {Tools_Back_HomeInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tools_back_home = /** @type {((inputs?: Tools_Back_HomeInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Back_HomeInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tools_back_home(inputs)
	return en_tools_back_home(inputs)
});